import {EventEmitter, Injectable} from '@angular/core';
import * as Stomp from 'stompjs';
import * as SockJS from 'sockjs-client';
import { HttpClient, HttpResponse } from '@angular/common/http';
import {Observable, Subject} from 'rxjs';
import { SERVER_API_URL } from 'app/app.constants';
import { Account } from 'app/core/user/account.model';
import {reject} from "q";
import {isNullOrUndefined} from "@swimlane/ngx-datatable/release/utils";
import {utils} from "protractor";
import {IMessage} from "../shared/model/chat.message.model";

@Injectable() // ({ providedIn: 'root' })
export class AccountService {
  private userIdentity: any;
  private authenticated = false;
  private authenticationState = new Subject<any>();
  // webSocketEndPoint: string =    'http://localhost:8089/ws';
  // webSocketEndPoint: string =    'http://localhost:8090/ws';
  webSocketEndPoint: string =   SERVER_API_URL + 'ws';
  // webSocketEndPoint: string =     'http://94.183.164.188/ws';
  // webSocketEndPoint: string =     'http://sandbox.dornikacrm.ir/ws';
  // webSocketEndPoint: string =        'http://demo.dornikacrm.ir/ws';
  // webSocketEndPoint: string =    /*'http://dornika.parsecompany.com/ws';
  // webSocketEndPoint: string =    'http://demo.parsecompany.com/ws';
  topicPrefix: string = "/queue/public.";
  topicPrefix2: string = "/topic/public."

  portServer: string ="";
  stompClient: any;
  stompClient2: any;

  chatMessageAdded = new EventEmitter();

  constructor(private http: HttpClient) {}

  fetch(): Observable<HttpResponse<Account>> {
    return this.http.get<Account>(SERVER_API_URL + 'api/account', { observe: 'response' });
  }

  getJWTToken(): string {
    return localStorage.getItem('authenticationToken') || sessionStorage.getItem('authenticationToken');
  }

  getWebSocketUUID(): string{
    return localStorage.getItem('webSocketUUID') || sessionStorage.getItem('webSocketUUID');
  }

  save(account: any): Observable<HttpResponse<any>> {
    return this.http.post(SERVER_API_URL + 'api/account', account, { observe: 'response' });
  }

  clearPath(path: string):  Observable<any>{
    // alert(path)

    return this.http.get(SERVER_API_URL + 'api/authenticate/clear-path?path=' + path );
  }


  authenticate(identity) {
    this.userIdentity = identity;
    this.authenticated = identity !== null;
    this.authenticationState.next(this.userIdentity);
  }

  hasAnyAuthority(authorities: string[]): boolean {
    if (!this.authenticated || !this.userIdentity || !this.userIdentity.authorities) {
      return false;
    }

    return authorities.some((authority: string) => this.userIdentity.authorities.includes(authority));
  }

  hasAuthority(authority: string): Promise<boolean> {
    if (!this.authenticated) {
      return Promise.resolve(false);
    }

    return this.identity().then(
      id => {
        return Promise.resolve(id.authorities && id.authorities.includes(authority));
      },
      () => {
        return Promise.resolve(false);
      }
    );
  }

  identity(force?: boolean): Promise<Account> {
    if (force) {
      this.userIdentity = undefined;
    }

    // check and see if we have retrieved the userIdentity data from the server.
    // if we have, reuse it by immediately resolving
    if (this.userIdentity) {
      return Promise.resolve(this.userIdentity);
    }

    // retrieve the userIdentity data from the server, update the identity object, and then resolve.
    return this.fetch()
      .toPromise()
      .then(response => {
        const account: Account = response.body;
        if (account) {
          // alert('account ---- >>> ' + JSON.stringify(account.authorities));
          this.userIdentity = account;
          this.authenticated = true;
          // After retrieve the account info, the language will be changed to
          // the user's preferred language configured in the account setting
          if (this.userIdentity.langKey) {
            //  const langKey = sessionStorage.retrieve('locale') || this.userIdentity.langKey;
            //   this.languageService.changeLanguage(langKey);
          }
        } else {
          this.userIdentity = null;
          this.authenticated = false;
        }
        this.authenticationState.next(this.userIdentity);
        return this.userIdentity;
      })
      .catch(err => {
        this.userIdentity = null;
        this.authenticated = false;
        this.authenticationState.next(this.userIdentity);
        return null;
      });
  }

  isAuthenticated(): boolean {
    return this.authenticated;
  }

  isIdentityResolved(): boolean {
    return this.userIdentity !== undefined;
  }

  getAuthenticationState(): Observable<any> {
    return this.authenticationState.asObservable();
  }

  getImageUrl(): string {
    return this.isIdentityResolved() ? this.userIdentity.imageUrl : null;
  }

  logoutAccount(path){
    this.userIdentity = null;
    this.authenticated = false;
    // alert('1111 ********************* ');
   // this.clearPath(path).subscribe(res =>{/*alert(' ********************* ')*/});
  }

  // notification part
  _connect(userName) {
//get the token to send for notification server
//    this.authService.getToken();
    // TODO comment notify
//     console.log("Initialize WebSocket Connection");
//     let ws = new SockJS(this.webSocketEndPoint);
//     this.stompClient = Stomp.over(ws);
//     this.stompClient.heartbeat.outgoing = 60000;
//     this.stompClient.heartbeat.incoming = 60000;
//
//     let ws2 = new SockJS(this.webSocketEndPoint);
//     this.stompClient2 = Stomp.over(ws2);
//     this.stompClient2.heartbeat.outgoing = 60000;
//     this.stompClient2.heartbeat.incoming = 60000;
//
//     const _this = this;
//     const jwt = this.getJWTToken();
//
//     // todo
//     console.log(" this is the fetch JWT token  ------ >>>>>>  " + jwt)
//
//     _this.stompClient.connect({token:jwt}, function (frame) {
//       _this.stompClient.subscribe(_this.topicPrefix + _this.getWebSocketUUID() , function (sdkEvent) {
//           _this.onMessageReceived(sdkEvent);
//         },
//         {token:jwt});
//       //_this.stompClient.reconnect_delay = 2000;
//     }, err=> this.errorCallBack(err));
//
//     let login: any;
//     _this.identity(false).then(res=>(
//       login = res.login
//     ))
//
//     _this.stompClient2.connect({token:jwt}, function (frame) {
//       // _this.stompClient2.subscribe(_this.topicPrefix2 + login + "-parskoosha" , function (sdkEvent) {
//       // _this.stompClient2.subscribe(_this.topicPrefix2 + login + "-pasargad" , function (sdkEvent) {
//       _this.stompClient2.subscribe(_this.topicPrefix2 + login + "-prod" , function (sdkEvent) {
//           _this.onMessageReceivedTopic(sdkEvent);
//         },
//         {token:jwt});
//       //_this.stompClient.reconnect_delay = 2000;
//     }, err=> this.errorCallBack(err));
    // TODO comment notify

  };

  _disconnect() {
    if (this.stompClient !== null) {
      this.stompClient.disconnect();
    }
    console.log("Disconnected");
  }

  // on error, schedule a reconnection attempt
  errorCallBack(error: any): any {
    console.log( 'console.log("errorCallBack -> '  + error)
    // setTimeout(() => {
    //  this.identity(true).then(account=> {
    //    if(!isNullOrUndefined(account))
    //    this._connect(account.login);},
    //      reject =>{console.log('can not connect to server')})
    // }, 5000);

    // if the connection interrupted cause of network error or else
    // client try to connect in every 50 seconds
    this.identity(false).then(account=> {
        setTimeout(() => {
          if(!isNullOrUndefined(account))

// TODO clear the stomp for the next web-socket connection
            if (this.stompClient !== null) {
              this._disconnect();
            }


            this._connect(account.login);}, 150000)
        ;},
      reject =>{console.log('can not connect to server')})
  }

  /**
   * Send message to sever via web socket
   * @param {*} message
   */
  _send(message) {
    console.log("calling logout api via web socket");
    // this.stompClient.send("/app/hello", {}, JSON.stringify(message));
    this.stompClient.send("/app/chat.sendMessage", {}, JSON.stringify(message));

  }

  onMessageReceived(message) {
    console.log("Message Recieved from Server :: " + message);

    this.chatMessageAdded.emit(message.body)

  }

  onMessageReceivedTopic(message) {
    console.log("Message Recieved from Server :: " + message);
    // sending received message to event Queue
    this.chatMessageAdded.emit(message.body);


    // reading content of the received message
    let m : IMessage;

    m = JSON.parse(message.body);

    console.log("  " +  m.content + "    " + m.type +  "  "  +  m.sender)
    //

  }


}
